import i18n from 'i18next';
import moment from 'moment';
import config from 'config';

// STRINGS
const recordingStatusPublished = 'PUBLISHED';

/**
 * Returns a url based on the recording action.
 *
 * @param action
 * @param recording
 * @returns {String}
 */
export function recordingOnActionUrl(action, contentKey) {
    let url;

    switch (action) {
    case 'preview' :
        url = `/watchNow/${contentKey}/edit`;
        break;

    case 'edit' :
        url = `/createContent/${contentKey}/create/upload`;
        break;

    case 'share' :
        url = `/watchNow/${contentKey}/edit`;
        break;

    case 'watchNow' :
        url = `/watchNow/${contentKey}/edit`;
        break;

    default:
        url = '/myRecordings';
    }

    return url;
}

/**
 * This function takes in the recording and returns the recording title.
 *
 * @param recording
 * @returns {*}
 */
export function recordingTitle(recording) {
    if (recording && recording.title) {
        return recording.title;
    }

    return i18n.t('helpers.recordingHelper.unknown');
}


/**
 * Returns the category name from the given recording
 *
 * @param recording
 * @param isDefaultImage
 * @returns {String} Category name.
 */
export function recordingCategory(recording) {
    const category = i18n.t('helpers.recordingHelper.selectCategory');
    return (recording.categories && recording.categories.length > 0) ? recording.categories[0].name.toUpperCase() : category;
}

/**
 * Calls the appropriate page by passing in the content id obtained from the self link of the recording.
 *
 * @param onRecordingClicked
 * @param recording
 */
export function recordingClicked(onRecordingClicked, recording) {
    const res = recording._links.self.href.split('/');

    if (recording.status === recordingStatusPublished) {
        onRecordingClicked(`/watchNow/${res.pop()}/private`);
    } else {
        onRecordingClicked(`/createContent/${res.pop()}/create/upload`);
    }
}

/**
 *
 * @param recording
 * @param dateFormat
 * @returns {*}
 */
export function recordingCreatedDate(date, dateFormat) {
    if (date) {
        return moment(date).format(dateFormat);
    }

    return i18n.t('helpers.recordingHelper.unknown');
}

/**
 *
 * @param recording
 * @returns {*}
 */
export function recordingDescription(recording) {
    if (recording && recording.description) {
        return recording.description;
    }

    return i18n.t('helpers.recordingHelper.unknown');
}

/**
 *
 * @param recording
 * @returns {null}
 */
export function recordingThumbnailPath(recording) {
    const thumbnailValue = `${config.assets.url}/images/MyRecordings/default_image.png`;
    return (recording && recording.attributes && recording.attributes.thumbnailUrl) ? recording.attributes.thumbnailUrl.value : thumbnailValue;
}

/**
 *
 * @param recordings
 * @param contentKey
 * @returns {{}}
 */
export function recordingFromRecordings(recordings, contentKey) {
    let recording = null;
    if (recordings && recordings.length > 0) {
        recordings.forEach(
            a => {
                if (a._links.self.href.split('/').pop() === contentKey) {
                    recording = a;
                }
            });
    }

    return recording;
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/recordingHelper.js